module.exports = __webpack_public_path__ + "static/media/rich_honey.a314be54.jpg";